import { Vector } from '@moleculeone/types';

interface PriceTreeLabelProps {
  point: Vector;
  scale: number;
  substrateId: string;
  labelMap: Record<string, string>;
}

export function PriceTreeLabel(props: PriceTreeLabelProps) {
  const { point, substrateId, labelMap } = props;

  if (!labelMap[substrateId]) {
    return null;
  }

  const size = 140;
  const endPointProps = {
    x: point[0] - 20,
    y: point[1] - size / 2,
    width: size,
    height: size,
  };

  return (
    <g>
      <rect
        x={endPointProps.x}
        y={endPointProps.y}
        width={endPointProps.width}
        height={endPointProps.height}
        fill="white"
        stroke="black"
        strokeWidth={1}
      />
      <text
        x={endPointProps.x + endPointProps.width / 2}
        y={endPointProps.y + endPointProps.height / 2 + 25}
        textAnchor="middle"
        fontSize={80}
      >
        {labelMap[substrateId]}
      </text>
    </g>
  );
}
